import type * as GraphQLTypes from '../../../graphql/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AddPackageTransferMutationVariables = GraphQLTypes.Exact<{
  packageId: GraphQLTypes.Scalars['String'];
  packageTransferInput: GraphQLTypes.CreateTransferPackageInput;
}>;


export type AddPackageTransferMutationResult = (
  { __typename?: 'Mutation' }
  & Pick<GraphQLTypes.Mutation, 'addPackageTransfer'>
);


export const AddPackageTransferDocument = /*#__PURE__*/ gql`
    mutation addPackageTransfer($packageId: String!, $packageTransferInput: CreateTransferPackageInput!) {
  addPackageTransfer(
    packageId: $packageId
    packageTransferInput: $packageTransferInput
  )
}
    `;

/**
 * __useAddPackageTransferMutation__
 *
 * To run a mutation, you first call `useAddPackageTransferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPackageTransferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPackageTransferMutation, { data, loading, error }] = useAddPackageTransferMutation({
 *   variables: {
 *      packageId: // value for 'packageId'
 *      packageTransferInput: // value for 'packageTransferInput'
 *   },
 * });
 */
export function useAddPackageTransferMutation(baseOptions?: Apollo.MutationHookOptions<AddPackageTransferMutationResult, AddPackageTransferMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddPackageTransferMutationResult, AddPackageTransferMutationVariables>(AddPackageTransferDocument, options);
      }
export type AddPackageTransferMutationHookResult = ReturnType<typeof useAddPackageTransferMutation>;